/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type InvitePolicyEnum = "AdminOnly" | "AnyMember" | "%future added value";
export type BulkInvite_billingGroups = {
    readonly list: ReadonlyArray<{
        readonly id: string;
        readonly name: string;
        readonly invitePolicy: InvitePolicyEnum;
        readonly adminOrgPersons: {
            readonly __typename: "OrgPersonList";
            readonly list: ReadonlyArray<{
                readonly isYou: boolean;
            }>;
        } | {
            readonly __typename: "GraphEntityError";
            readonly message: string | null;
            readonly statusCode: number | null;
        } | {
            /*This will never be '%other', but we need some
            value in case none of the concrete values match.*/
            readonly __typename: "%other";
        };
    }>;
    readonly " $refType": "BulkInvite_billingGroups";
};
export type BulkInvite_billingGroups$data = BulkInvite_billingGroups;
export type BulkInvite_billingGroups$key = {
    readonly " $data"?: BulkInvite_billingGroups$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"BulkInvite_billingGroups">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "BulkInvite_billingGroups",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "BillingGroup",
            "kind": "LinkedField",
            "name": "list",
            "plural": true,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "invitePolicy",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "adminOrgPersons",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "__typename",
                            "storageKey": null
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "OrgPerson",
                                    "kind": "LinkedField",
                                    "name": "list",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "isYou",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "type": "OrgPersonList",
                            "abstractKey": null
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "message",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "statusCode",
                                    "storageKey": null
                                }
                            ],
                            "type": "GraphEntityError",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "BillingGroupList",
    "abstractKey": null
} as any;
(node as any).hash = '10028c8cfb14749440529698b8beb056';
export default node;
